import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AppLinkType } from "../types/appTypes";

const AppLink: React.FC<AppLinkType> = ({ path, text }) => {
  const location = useLocation();
  // Active if pathname matches exactly OR is a sub-route (e.g. /wallets/bogowi
  // should keep the "Wallets" nav item highlighted).
  const isActive =
    location.pathname === path ||
    (path !== "/" && location.pathname.startsWith(path + "/"));

  return (
    <Link
      to={path}
      className="inline-flex items-center h-10 px-3 text-[0.9375rem] font-medium text-ink hover:text-accent transition-colors whitespace-nowrap"
    >
      {/* Underline sits on an inner span so it appears directly under the
          text rather than at the bottom of the 40px flex container. */}
      <span className={isActive ? "border-b border-ink pb-[3px]" : ""}>
        {text}
      </span>
    </Link>
  );
};

export default AppLink;
